const STEP1 = {
  target: '[data-tour="header__profile"]',
  content: 'Пройти обучающий тур повторно можно в разделе «Профиль»',
  hideCloseButton: true,
  disableBeacon: true,
  hideSkipButton: true,
};
const LASTS = [STEP1];
export default LASTS;
